import { IApplicationState } from '../../types/redux';
import { ISort } from '../../types/sort';

export const getActiveSort = (state: IApplicationState): ISort | null => {
  const sort = state.sort.find(item => item.isSelected);

  return sort ?? null;
};
